import React, { FC } from 'react'

import styled from 'styled-components'

import { Track } from 'src/Redux/firstTrackApi'
import { CampaignPlatformTypeEnum } from 'src/Types/campaigns'
import { MAX_MOBILE_WIDTH } from 'src/Styled/variables'
import {
  ArtistContactDetailsForm,
  FormDataProps,
} from 'src/Components/ArtistContactDetailsForm'

import { TrackDetails } from '../TrackDetails'

const Container = styled.div`
  display: flex;
  padding: 24px 40px 24px 24px;
  justify-content: center;
  align-items: center;
  gap: 40px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid ${(props) => props.theme.color.lightGrey};
  background-color: ${(props) => props.theme.color.white};
  box-shadow: ${(props) => props.theme.shadow.card};

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    display: flex;
    border: none;
    box-shadow: none;
    padding: 0;
    flex-direction: column;
    align-items: center;
    gap: 40px;
  }
`

const StyledArtistContactDetailsForm = styled(ArtistContactDetailsForm)`
  flex-basis: calc(50% - 48px);

  @media (max-width: ${MAX_MOBILE_WIDTH}) {
    flex-basis: unset;
  }
`

interface ArtistRegisterContentProps {
  isEmailExist: boolean
  clearEmailExist: () => void
  isRegisterLoading?: boolean
  onSubmitRegisterForm: (data: FormDataProps, token: string) => Promise<void>
  onGoogleClick: () => void
  onStartFillingForm: () => void
  platform?: CampaignPlatformTypeEnum
  isTrackDataLoading?: boolean
  trackCoverUrl: Track['trackCoverUrl']
  trackName: Track['trackName']
  artistName: Track['artistName']
  trackDuration: Track['trackDuration']
  trackPreviewUrl: Track['trackPreviewUrl']
}

export const ArtistRegisterContent: FC<ArtistRegisterContentProps> = ({
  onSubmitRegisterForm,
  onGoogleClick,
  isRegisterLoading,
  onStartFillingForm,
  isEmailExist,
  clearEmailExist,
  platform,
  isTrackDataLoading,
  trackCoverUrl,
  trackName,
  artistName,
  trackDuration,
  trackPreviewUrl,
}) => (
  <Container>
    <StyledArtistContactDetailsForm
      onSubmit={onSubmitRegisterForm}
      onGoogleClick={onGoogleClick}
      isEmailExist={isEmailExist}
      clearEmailExist={clearEmailExist}
      onStartFillingForm={onStartFillingForm}
      loading={isRegisterLoading}
    />

    <TrackDetails
      platform={platform}
      coverUrl={trackCoverUrl}
      trackName={trackName}
      trackAuthorName={artistName}
      duration={trackDuration}
      trackPreviewUrl={trackPreviewUrl}
      isTrackDataLoading={isTrackDataLoading}
    />
  </Container>
)
